import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {newsCompanyId} from 'yougile-model'
import {LinkButton} from '@components/common/base/buttons'
import {ExtensionStore} from '@components/extensions-gallery/extensions-store'
import {FileViewer} from '@components/file-viewer/file-viewer'
import {Chat} from '@components/right-panel/chat'
import {
  RightPanelContentContext,
  RightPanelContentStore
} from '@components/right-panel/right-panel-content/right-panel-content-store'
import {TaskChatQuickLinkList} from '../../../chat/chat-header/task-chat-quick-link-list'

const TwMainDetails = tw.div`
  flex-1
  flex
  flex-col
  h-full
  w-full
  overflow-hidden
`

const TwMainDetailsHeader = tw.div`
	pt-8
  pb-12
  px-24
  shadow-border-b-1
  shadow-grey-l60
`

const TwMainDetailsHeaderTitle = tw.div`
  text-primary
  h1-semibold
  mt-4
`

const TwMainDetailsNoCommentsHub = tw.div`
  flex
  items-center
  justify-center
  w-full
  h-full
`

type ExtensionDetailsMainProps = {
  openedDetails: ExtensionStore
  onCloseDetails: () => void
}

export const ExtensionDetailsMain = observer(
  (props: ExtensionDetailsMainProps) => {
    const {openedDetails, onCloseDetails} = props
    const [rightPanelContentStore] = useState(
      () => new RightPanelContentStore()
    )

    const hub = openedDetails.commentsHub

    return (
      <TwMainDetails>
        <RightPanelContentContext.Provider value={rightPanelContentStore}>
          <TwMainDetailsHeader>
            <LinkButton icon="IconArrowLeft" onClick={onCloseDetails}>
              {Lang.msg.extensions.gallery.goBackToGallery}
            </LinkButton>
            <TwMainDetailsHeaderTitle>
              {openedDetails.name}
            </TwMainDetailsHeaderTitle>
            {hub && hub.companyId === newsCompanyId && (
              <TaskChatQuickLinkList
                chatId={hub.id}
                companyId={hub.companyId}
                paddings="p-0 mt-12"
                containerSelector=".extension-comments"
              />
            )}
          </TwMainDetailsHeader>

          {!hub ? (
            <TwMainDetailsNoCommentsHub>
              {Lang.msg.extensions.gallery.noCommentsYet}
            </TwMainDetailsNoCommentsHub>
          ) : (
            <>
              <Chat hub={hub} noTabs={true} autofocus headerHeight={100} />

              {Boolean(
                rightPanelContentStore.state.selectedFilesToView.length
              ) && (
                <FileViewer
                  autoplay
                  files={rightPanelContentStore.state.selectedFilesToView}
                  selectedIndex={
                    rightPanelContentStore.state.selectedFileToViewIndex
                  }
                  onClose={() => rightPanelContentStore.closeFileViewer()}
                />
              )}
            </>
          )}
        </RightPanelContentContext.Provider>
      </TwMainDetails>
    )
  }
)
